// extracted by mini-css-extract-plugin
export var dropdownButton = "_1b-0";
export var fullWidthDropdownButton = "_1b-1";
export var icon = "_1b-3";
export var iconPlaceholder = "_1b-2";
export var menuItemRow = "_1b-8";
export var separator = "_1b-c";
export var shortcutContainer = "_1b-7";
export var shortcutIconLg = "_1b-6";
export var shortcutIconMd = "_1b-5";
export var shortcutIconSm = "_1b-4";
export var submenuChevron = "_1b-b";
export var submenuDropdown = "_1b-9";
export var submenuTriggerRow = "_1b-a";